export interface BrightEdgeNode {
  type: string;
  content: string;
  feature_group?: string;
  engine_version?: string;
  date_published?: number;
  date_created?: number;
  publishing_engine?: string;
}

export interface BrightEdgeProps {
  nodes: BrightEdgeNode[];
  [key: string]: unknown;
}

export async function fetchBrightEdge(
  pageUrl: string,
): Promise<BrightEdgeProps | null> {
  try {
    const accountId = "f00000000315051";
    const pageHash = hashUrl(pageUrl);
    const url = `https://ixfd1-api.bc0a.com/api/ixf/1.0.0/get_capsule/${accountId}/${pageHash}?format=json`;

    const response = await fetch(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      console.warn(
        `[BrightEdge] API returned ${response.status}: ${response.statusText}`,
      );
      return null;
    }

    const data = await response.json();
    console.log("[BrightEdge] Successfully fetched data");
    return data;
  } catch (error) {
    console.error("[BrightEdge] Error fetching data:", error);
    return null;
  }
}

function hashUrl(pageUrl: string): string {
  let hash = 0;

  for (let i = 0; i < pageUrl.length; i++) {
    const charCode = pageUrl.charCodeAt(i);
    hash = (hash << 5) - hash + charCode;
    hash = hash & hash;
  }

  if (hash < 0) {
    return "0" + String(-hash);
  }

  return String(hash);
}
